import { React, useState } from "react";
import Person3Icon from '@mui/icons-material/Person3';
import ForumIcon from '@mui/icons-material/Forum';
import BannerBreadcrumb from "../Components/BannerBreadcrumb";
const BlogDescription = () => {
    const [formData, setFormData] = useState({
        type: "Blog",
        name: "",
        email: "",
        phone: ""
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});

    const validate = () => {
        const errors = {};
        // Name: only letters and spaces
        if (!/^[a-zA-Z\s]*$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        // Phone: must be 10 digits, numeric only
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        // Email: basic email regex
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        // For phone, allow only digits
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        // For name, allow only letters and spaces
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                type: "Blog",
                name: "",
                email: "",
                phone: ""
            });
        } catch (err) {
            console.error("Error submitting form:", err);
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    return (
        <>
            <BannerBreadcrumb head={"Blog Description"} pagename={"Blog Description"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility ">
                            <h5 className="about-head">A Comprehensive Guide for International Students on Securing Internships in the US</h5>
                            <img src="/images/blog.jpg" alt="Blog Image" className="img-fluid mb-4" />
                            <p className="loan-elegibility-des">
                            Welcome to our complete guide designed specifically for individuals who are ready to pursue internships abroad. Navigating the procedure of finding internships in a foreign nation may be challenging, but don't worry—we're here to assist you with all the necessary steps and information to help you succeed.
                            </p>

                            <h5 className="about-head">A Path to Fulfilling Your Goals</h5>
                            <p className="loan-elegibility-des">
                            Internships serve as a vital bridge between your academic journey and the professional world. They offer a unique opportunity to apply classroom knowledge in real-world settings, strengthening your practical skills and bringing you closer to your career goals.
                            </p>

                            <h5 className="about-head">Examine a Range of Opportunities</h5>
                            <p className="loan-elegibility-des">
                            Don’t limit yourself to conventional options. Explore your university’s resources, browse online job boards, and leverage your network of mentors, professors, and peers. Sometimes, the best opportunities come from the most unexpected places.
                            </p>

                            <h5 className="about-head">Stay Tough When Encountering Obstacles</h5>
                            <p className="loan-elegibility-des">
                            Rejection is a natural part of the process. Every "no" is a learning opportunity that helps refine your strategy and brings you closer to success. Stay persistent and view setbacks as stepping stones to achieving your goals.
                            </p>

                            <h5 className="about-head">Utilize the Assistance Services Provided by the University</h5>
                            <p className="loan-elegibility-des">
                            Take full advantage of your school’s career services. Consult professors, advisors, and career counselors for guidance. These experts can provide personalized insights to strengthen your applications and interviews.
                            </p>

                            <h5 className="about-head">Give Careful Consideration to Each Application</h5>
                            <p className="loan-elegibility-des">
                            Focus on quality over quantity. Tailor each resume and cover letter to the specific role and company. Highlight your strengths and experiences that directly match the employer’s needs to stand out from other candidates.
                            </p>

                            <h5 className="about-head">Explore Virtual Internship Opportunities</h5>
                            <p className="loan-elegibility-des">
                            With the evolving job market, virtual internships are increasingly popular. They allow you to gain experience with organizations worldwide from the comfort of your home. Be proactive in searching for remote roles that align with your career goals.
                            </p>

                            <h5 className="about-head">Enhance Your Professional Skills</h5>
                            <p className="loan-elegibility-des">
                            Never stop learning. Continuously improve your skills through online courses, seminars, and workshops. Engage with professionals in your field to exchange ideas and stay current with industry trends.
                            </p>

                            <h5 className="about-head">Make Your Online Presence</h5>
                            <p className="loan-elegibility-des">
                            Build a strong online profile—especially on LinkedIn or a personal portfolio site. This digital presence showcases your work, qualifications, and achievements, making you more visible to potential employers.
                            </p>

                            <h5 className="about-head">Engage with Former Students and Experts in the Field</h5>
                            <p className="loan-elegibility-des">
                            Networking with alumni and professionals can open doors to mentorships and job leads. Learn from their experiences and build meaningful connections that can guide your internship journey.
                            </p>

                            <h5 className="about-head">Maintain a Positive Mindset and Keep Going</h5>
                            <p className="loan-elegibility-des">
                            The search for the right internship can take time. Stay motivated, trust in your abilities, and continue applying. The right opportunity is out there—persistence and positivity will lead you to it.
                            </p>

                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Need Help in education loan?</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3">Register Now</button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Best Landing Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BlogDescription;